import { Button } from "@/components/ui/button";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function AIPrivacyPolicy() {
  const lastUpdate = new Date("2025-11-17").toLocaleDateString("pt-BR");
  return (
    <div className="dark min-h-screen bg-slate-950 text-white overflow-x-hidden">
      <PublicHeader />
      <section className="relative min-h-[320px] flex items-center overflow-hidden pt-16">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(/fundo-landing-page-1.jpg)' }} />
        <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-primary/70 to-secondary/80" />
        <div className="container mx-auto px-8 py-16 relative z-10">
          <h1 className="text-3xl md:text-5xl font-bold">Política de Privacidade para IA/ML</h1>
          <p className="mt-3 text-sm md:text-base opacity-90">Última atualização: {lastUpdate}</p>
        </div>
      </section>
      <div className="container mx-auto px-4 py-12 max-w-3xl">

        <p className="mb-6 text-lg">
          Esta política complementa a nossa Política de Privacidade e descreve como tratamos dados quando você ativa recursos de Inteligência Artificial (IA) no Caixa Fácil Já.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Escopo</h2>
        <p className="mb-6">
          Os recursos de IA são opcionais e servem para facilitar atendimento, busca de informações e automações. Eles funcionam com os dados que você cadastra no sistema, como produtos, clientes, documentos e históricos.
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Dados utilizados pela IA</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Conteúdos e registros que você adiciona ao sistema (produtos, clientes, vendas, despesas, bases de conhecimento).</li>
          <li>Mensagens e perguntas feitas aos assistentes de IA.</li>
        </ul>
        <p className="mb-6">Não utilizamos conteúdo do Google Workspace (Gmail, Drive, Calendário etc.) para treinar modelos. O login com Google serve apenas para autenticação.</p>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Como a IA usa os dados</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Responder perguntas e auxiliar em tarefas do dia a dia com base nos seus próprios dados.</li>
          <li>Realizar buscas em suas bases cadastradas para encontrar informações relevantes.</li>
          <li>Gerar textos de apoio e recomendações operacionais.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Treinamento e modelos</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Não usamos seus dados para treinar modelos públicos.</li>
          <li>Podemos armazenar suas bases de conhecimento e histórico de uso para melhorar a precisão do seu próprio assistente, exclusivamente dentro do seu ambiente.</li>
          <li>Você pode desativar recursos de IA a qualquer momento nas configurações.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Compartilhamento com terceiros</h2>
        <p className="mb-6">Quando necessário, os recursos de IA podem utilizar provedores de modelos de linguagem. Nestes casos:</p>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Enviamos apenas o mínimo necessário para responder às suas solicitações.</li>
          <li>Não autorizamos uso dos seus dados para treinar modelos gerais dos provedores.</li>
          <li>Os provedores são selecionados considerando segurança e conformidade.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Segurança e retenção</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Suas bases e interações são armazenadas com controles de acesso e criptografia em trânsito.</li>
          <li>Você pode solicitar exclusão das bases e do histórico de IA.</li>
          <li>Retemos apenas o necessário para operar o serviço e cumprir obrigações legais.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-10 mb-4">Consentimento e controle</h2>
        <ul className="list-disc pl-6 space-y-2 mb-6">
          <li>Os recursos de IA são opt‑in. Ao ativá‑los, você concorda com o uso descrito nesta política.</li>
          <li>Você pode desativar a IA e solicitar exclusão dos dados a qualquer momento.</li>
        </ul>

        <div className="mt-10 flex gap-4">
          <Button asChild>
            <a href="/">Voltar para página inicial</a>
          </Button>
          <Button variant="outline" asChild>
            <a href="/politica-de-privacidade">Política de Privacidade Geral</a>
          </Button>
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
